<template>
  <div class="boxs">
    <div class="item" @click="toDetail"><i class="el-icon-edit"></i></div>
    <div class="item">

      <el-popconfirm title="这是一条资讯确定删除吗？" @confirm="delconfirm">
        <i slot="reference" class="el-icon-delete"></i>
      </el-popconfirm>
    </div>


    <template>
      <el-dialog class="editUp" :append-to-body="true" center :visible.sync="dialogVisible" @close="closeReturn"
        width="40%">
        <div slot="title" class="title">
          <span>资讯动态编辑</span>
        </div>
        <!-- <div class="label">
                  <span>指示器：</span> <el-radio v-model="radio" label="1">显示</el-radio>
                  <el-radio v-model="radio" label="2">不显示</el-radio>
                </div> -->
        <div class="table">
          <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm">
            <el-form-item label="案例标题" prop="title">
              <el-input v-model="form.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="缩阅图" prop="thumbnail">
              <div class="upimg">
                <UploadImg @onSuccess="onSuccess">
                  <img v-if="form.thumbnail" :src="form.thumbnail" class="avatar" style="width: 100%;">
                  <i v-else size="50" class="el-icon-plus avatar-uploader-icon"></i>
                </UploadImg>
                <p>建议图片尺寸400*260</p>
              </div>
            </el-form-item>
            <el-form-item label="所属区域" prop="address">
              <el-select v-model="form.address" placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in provs" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="案例标签" prop="label">
              <el-select v-model="form.label" placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in options" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="其它标签">
              <el-input type="text" placeholder="请输入标签名称" v-model="form.labelMore">
              </el-input>
              <div class="msg">
                <p>注：多个用;分隔</p>
              </div>

            </el-form-item>
            <el-form-item label="案例简介" prop="content">
              <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.content">
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="案例文件" prop="fileUrl">
              <UploadPdf @onSuccess="UpSuccessPdf">
                <div class="upBtn">
                  <div>
                    <el-button size="small" type="primary">文件上传</el-button>
                  </div>
                  <div v-if="form.fileUrl" class="text">文件地址：{{ form.fileUrl }}</div>
                </div>

              </UploadPdf>
            </el-form-item>
            <el-form-item label="案例亮点">
              <UploadImgMore ref="filelist" @onReturn="onReturn"></UploadImgMore>
            </el-form-item> -->

          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="onSave">保存</el-button>
        </span>
      </el-dialog>
    </template>
  </div>
</template>
        
<script>
import UploadImg from "./uploadImg.vue"
// import UploadImgMore from "./uploadImgMore.vue"
import { delClassicCase,addClassicCase } from "@/api/case.js"
import cityJson from "../components/map.json"
import { createMapOptions } from "@/utils/mapLocale";
// import UploadPdf from "./uploadPdf.vue"
export default {
  props: ['data'],
  components: {
    UploadImg,
    // UploadImgMore,
    // UploadPdf
  },
  data() {
    return {
      dialogVisible: false,
      radio: '1',
      form: {},
      editData: [],
      imageUrl: "",
      typeList: [],
      provs: [],
      options: ['测绘服务', '数据服务', '数智应用'],
      rules: {
        address: [
          { required: true, message: '请选择区域', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        label: [
          { required: true, message: '请输入选择标签', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入资讯简介', trigger: 'blur' },
          { min: 3, max: 500, message: '长度在 3 到 500 个字符', trigger: 'blur' }
        ],
        thumbnail: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        fileUrl: [
          { required: true, message: '请输入详情链接', trigger: 'blur' },
        ],
      }
    }
  },
  mounted() {
    this.provs = createMapOptions(cityJson, this.$store.state.language);
  },
  methods: {
    toDetail() {
      this.$router.push({
        path: '/caseMod',
        query: {
          CaseId: this.data.id
        }
      })
    },
    showUp() {
      this.editData = this.tableData;
      this.dialogVisible = true;
      let obj = JSON.parse(JSON.stringify(this.data));

      let arrLaber = obj.label || []
      obj.label = arrLaber[0]
      obj.labelMore = [];
      arrLaber.forEach((e, i) => {
        if (i !== 0) {
          obj.labelMore.push(e)
        }

      })
      this.form = obj
      // this.$nextTick(() => {
      //   this.$refs.filelist.setfileList(obj.highlightsList)
      // })

    },
    del(e) {
      this.tableData.splice(e.$index, 1)
    },
    UpSuccessPdf(e) {
      this.$set(this.form, 'fileUrl', e.fileUrl)
    },
    onSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let params = {
            ...this.form,
            isRelease: 0,
          }
          // this.$refs.filelist.getData(params);
          addClassicCase(params).then(res => {
            if(res.code == 200) {
              this.$message.success('操作成功')
              this.onReturn()
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    delconfirm() {
      delClassicCase({ id: this.data.id }).then(res => {
        this.$message.success('删除成功')
        this.$emit("onReturn")
      })
    },
    onSuccess(e) {
    },
    onReturn() {
      this.dialogVisible = false;
      this.$emit('onReturn')
    },
    closeReturn() {
      this.$emit('onReturn')
    }
  }
}
</script>
        
<style lang="scss" scoped>
.boxs {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;

  .item {
    padding: 5px 10px;
    background: #007ffe;
    font-style: normal;
    align-items: center;
    display: none;

    cursor: pointer;
    color: #666;
    height: 20px;

    i {
      color: #fff;
    }

    &:first-child {
      border-top-left-radius: 4px;
    }

  }

  &:hover {
    border: 1px dashed #ccc;
    display: inline-flex;
    justify-content: flex-end;
    align-items: flex-end;

    .item {
      display: inline-flex;
      font-size: 14px;
    }
  }
}





::v-deep .table {
  .img {
    width: 100px;
    height: 50px;
  }

  .upBtn {
    text-align: left;
  }

  .msg {
    p {
      font-size: 12px !important;
      color: #999;
    }
  }

  .upimg {
    width: 150px;
    height: 100px;
    margin-bottom: 20px;

    p {
      font-size: 12px;
      color: #999;
    }

    .avatar-uploader {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-upload {
        display: flex;
        align-items: center;
        justify-content: center;

        .el-icon-plus {
          font-size: 30px;
          color: #999;
        }
      }
    }
  }
}

.dialog-foote {
  text-align: center;
  display: flex;
  justify-content: center;
}
</style>
